import React, { useState } from 'react';

import PaymentMethod from './components/PaymentMethod';
import PaymentMethodEdit from './components/PaymentMethodEdit';

const PaymentMethodWrapper = ({ hasBillingAddress = true }) => {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return <PaymentMethodEdit setEditing={setEditing} />;
  }

  return <PaymentMethod setEditing={setEditing} hasBillingAddress={hasBillingAddress} />;
};

export default PaymentMethodWrapper;
